module.exports = __webpack_public_path__ + "img/girl.d2a5845f.jpg";